module.exports = "<mat-form-field>\n    <mat-select [formControl]=\"control\" name=\"role\" [disabled]=\"canEdit === false\">\n        <mat-option *ngFor=\"let role of roles\" [value]=\"role\">\n            {{ role.label }}\n        </mat-option>\n    </mat-select>\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/role.component.html
// module id = ../../../../../src/swarm/src/app/fields/role.component.html
// module chunks = main